<template>
  <div>
    <svg ref="gantt" />
  </div>
</template>

<script>
import Gantt from 'frappe-gantt'
export default {
  name: 'FrappeGantt',
  props: {
    viewMode: {
      type: String,
      required: false,
      default: 'Month'
    },
    tasks: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  watch: {
    viewMode () {
      this.updateViewMode()
    },
    tasks () {
      this.updateTasks()
    }
  },
  mounted () {
    this.setupGanttChart()
    this.setFunctionDeleteBtn()
  },
  methods: {
    setupGanttChart () {
      this.gantt = new Gantt(this.$refs.gantt, this.tasks, {
        // options setup for display of tasks in gantt
        header_height: 80,
        language: 'en',
        column_width: 12,
        bar_height: 40,
        padding: 24,
        step: 12,
        bar_corner_radius: 0,
        arrow_curve: 5,
        date_format: this.formatDate,
        popup_trigger: 'click',
        drag: false,
        custom_popup_html: function (task) {
          // the task object will contain the updated
          // dates and progress value
          // const end_date = task._end
          // <p class="line-height-1 mb1"><span class="semi-bold">Price: </span>${task.price}</p>
          return `
          <div class="details-container">
            <P class="semi-bold line-height-1 mb1">${task.name}</P>
            <p class="line-height-1 mb2">${task.description}</p>
            <p class="line-height-1 mb1"><span class="semi-bold">Start:</span> ${task.start}</p>
            <p class="line-height-1 mb1"><span class="semi-bold">End:</span> ${task.end}</p>
            <p><span class="semi-bold">Status: </span>${task.progress}%</p>
            ${task.submitted === 0 ? `<i id="${task.jobId}" class="red delete-timeline-btn el-icon-delete" style="cursor:pointer;"></i>` : ``}</div>
            `
        },
        // end options
        on_click: (task) => {
          // this.$emit('task-updated', task)
        },

        on_date_change: (task, start, end) => {
          this.$emit('task-date-updated', { task, start, end })
        },

        on_progress_change: (task, progress) => {
          this.$emit('task-progress-updated', { task, progress })
        },

        // I doubt you will ever need this as the developer already knows what view mode they set.
        on_view_change: (mode) => {
          this.$emit('view-mode-updated', mode)
        }
      })

      this.updateTasks()
      this.updateViewMode()
    },

    updateViewMode () {
      const words = this.viewMode
      const finalWords = words.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
      this.gantt.change_view_mode(finalWords)
    },
    updateTasks () {
      this.gantt.refresh(this.tasks)
    },
    setFunctionDeleteBtn () {
      var thisVar = this
      var viewedId = ''
      setInterval(function () {
        var deleteBtn = document.querySelectorAll('.delete-timeline-btn')
        for (var i = 0; i < deleteBtn.length; i++) {
          if (deleteBtn[i].id !== viewedId) {
            viewedId = deleteBtn[i].id
            deleteBtn[i].addEventListener('click', function (e) {
              thisVar.$emit('confirmDelete', e.target.id)
            })
          }
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.details-container {
  padding: 1rem;
  font-size:14px;
}
.gantt .grid-background {
  fill: none;
}

.gantt .grid-header {
  fill: #ffffff;
  stroke: #e0e0e0;
  stroke-width: 1.4;
}

.gantt .grid-row {
  fill: #ffffff;
}

.gantt .grid-row:nth-child(even) {
  fill: #f5f5f5;
}

.gantt .row-line {
  stroke: #ebeff2;
}

.gantt .tick {
  stroke: #e0e0e0;
  stroke-width: 0.2;
}
.gantt .tick.thick {
  stroke-width: 0.4;
}

.gantt .today-highlight {
  fill: #fcf8e3;
  opacity: 0.5;
}

.gantt .arrow {
  fill: none;
  stroke: #666;
  stroke-width: 1.4;
}

.gantt .bar {
  fill: #003645;
  stroke: #8d99a6;
  stroke-width: 0;
  transition: stroke-width 0.3s ease;
  user-select: none;
}

.gantt .bar-progress {
  fill: rgba(77, 207, 85, 1.0);
}

.gantt .bar-invalid {
  fill: transparent;
  stroke: #8d99a6;
  stroke-width: 1;
  stroke-dasharray: 5;
}
.gantt .bar-invalid ~ .bar-label {
  fill: #555;
}

.gantt .bar-label {
  fill: #fff;
  text-anchor: middle;
  font-size: 14px;
  font-weight:600;
}
.gantt .bar-label.big {
  fill: #555;
  text-anchor: start;
}

.gantt .handle {
  fill: #ddd;
  cursor: ew-resize;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
}

.gantt .bar-wrapper {
  cursor: pointer;
  outline: none;
}
.gantt .bar-wrapper:hover .bar {
  fill: #003645;
}
.gantt .bar-wrapper:hover .bar-progress {
  fill: rgba(77, 207, 85, 1.0);
}
.gantt .bar-wrapper:hover .handle {
  visibility: visible;
  opacity: 1;
}
.gantt .bar-wrapper.active .bar {
  fill: #003645;
}
.gantt .bar-wrapper.active .bar-progress {
  fill: rgba(77, 207, 85, 1.0);
}

.gantt .lower-text,
.gantt .upper-text {
  text-anchor: middle;
}

.gantt .upper-text {
  fill: #003645;
  transform: translateY(-18px);
  font-size:18px;
}

.gantt .lower-text {
  fill: #003645;
  font-size: 15px;
}

.gantt .hide {
  display: none;
}

.gantt-container {
  position: relative;
  overflow: auto;
  font-size: 12px;
}
.gantt-container .popup-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255,255,255,1);
  padding: 0;
  color: #003645;
  border-radius: 0;
  box-shadow: 0px 3px 15px #0000000D;
  border: 1px solid #E8E8E8;
  opacity: 1;
  min-width:240px;
  min-height:120px;
}
.gantt-container .popup-wrapper .title {
  border: 0;
  padding: 10px;
  font-size: 15px;
  font-weight:600;
}
.gantt-container .popup-wrapper .subtitle {
  padding: 10px;
  color: #003645;
}
.gantt-container .popup-wrapper .pointer {
  position: absolute;
  height: 5px;
  margin: 0 0 0 -5px;
  border: 5px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.8);
}
</style>


// WEBPACK FOOTER //
// frappe-gantt.vue?8dc25a04